import { useState } from 'react'
import { Sidebar } from '@/components/dashboard/sidebar'
import { Header } from '@/components/dashboard/header'
import { D1ConnectionBanner } from '@/components/dashboard/d1-connection-banner'
import { cn } from '@/lib/utils'
import { D1_WORKER_URL } from '@/lib/constants'

export default function DashboardLayout({ children }: { children?: React.ReactNode }) {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false)
  const [mobileSidebarOpen, setMobileSidebarOpen] = useState(false)

  return (
    <div className="flex h-screen bg-background overflow-hidden">
      {/* Mobile overlay */}
      {mobileSidebarOpen && (
        <div
          className="fixed inset-0 z-40 bg-background/80 backdrop-blur-sm md:hidden"
          onClick={() => setMobileSidebarOpen(false)}
        />
      )}

      {/* Sidebar — desktop */}
      <div
        className={cn(
          'hidden md:flex flex-col flex-shrink-0 transition-all duration-200',
          sidebarCollapsed ? 'w-16' : 'w-60'
        )}
      >
        <Sidebar collapsed={sidebarCollapsed} />
      </div>

      {/* Sidebar — mobile */}
      <div
        className={cn(
          'fixed inset-y-0 left-0 z-50 flex flex-col transition-transform duration-200 md:hidden',
          mobileSidebarOpen ? 'translate-x-0' : '-translate-x-full'
        )}
      >
        <Sidebar collapsed={false} />
      </div>

      {/* Main content */}
      <div className="flex flex-col flex-1 min-w-0 overflow-hidden">
        <Header onMenuToggle={() => setMobileSidebarOpen((v) => !v)} />

        {/* Collapse toggle */}
        <button
          onClick={() => setSidebarCollapsed((v) => !v)}
          className="hidden md:flex absolute top-1/2 -translate-y-1/2 z-30 w-5 h-10 items-center justify-center bg-background border border-border hover:bg-lava/10 hover:border-lava/40 transition-colors rounded-r-md shadow-sm"
          aria-label="Toggle sidebar"
          style={{ left: sidebarCollapsed ? '64px' : '240px' }}
        >
          <svg
            className={cn('w-3 h-3 text-muted-foreground transition-transform', sidebarCollapsed && 'rotate-180')}
            viewBox="0 0 12 12" fill="none" stroke="currentColor" strokeWidth="1.5"
          >
            <path d="M7.5 9L4.5 6l3-3" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </button>

        <main className="flex-1 overflow-y-auto">
          <div className="max-w-screen-2xl mx-auto p-4 md:p-6">
            <D1ConnectionBanner workerUrl={D1_WORKER_URL} />
            {children}
          </div>
        </main>
      </div>
    </div>
  )
}
